export default __webpack_public_path__ + "static/media/awesome-resume.b0901941.jpg";